import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Anchor } from '@atlaskit/primitives/compiled';

interface BookmarkInvisibleLinkProps {
	url: string;
	onClick: () => void;
	onMouseEnter?: () => void;
	onMouseLeave?: () => void;
	label: string;
	testId?: string;
}

const styles = cssMap({
	root: {
		position: 'absolute',
		top: '0',
		left: '0',
		width: '100%',
		height: '100%',
		backgroundImage: 'none',
		backgroundColor: 'transparent',
		appearance: 'none',
		padding: '0',
	},
});

// It is invalid (and not accessible) to put an html button/link inside another button.
// so to make the full bookmark card clickable without nesting buttons, we style it absolute and full size.
export const BookmarkInvisibleLink = ({
	url,
	onClick,
	onMouseEnter = () => {},
	onMouseLeave = () => {},
	label,
	testId = 'bookmark-card-link',
}: BookmarkInvisibleLinkProps): React.JSX.Element => (
	<Anchor
		href={url}
		xcss={styles.root}
		onClick={onClick}
		onMouseEnter={onMouseEnter}
		onMouseLeave={onMouseLeave}
		aria-label={label}
		tabIndex={-1}
		data-testId={testId}
	/>
);
